import { render, staticRenderFns } from "./ImgSbp.vue?vue&type=template&id=60abb8aa&scoped=true&"
import script from "./ImgSbp.vue?vue&type=script&lang=js&"
export * from "./ImgSbp.vue?vue&type=script&lang=js&"
import style0 from "./ImgSbp.vue?vue&type=style&index=0&id=60abb8aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60abb8aa",
  null
  
)

export default component.exports